import { useTournament, useTournamentUpdate } from "../TournamentContext";
import TeamCard from "./components/TeamCard";
import SectionTitle from "../../../components/SectionTitle";
import Button from "../../../components/Button";
import AddMockTeams from "./components/AddMockTeams";
import { firestore } from "../../../firebase/config";
import { doc, updateDoc } from "firebase/firestore";
import CreateMixerTeams from "./components/CreateMixerTeams";

const Teams = () => {
  const { tournament, tournamentId, teams, isUserOrganizer, profiles } =
    useTournament();
  const { isTeamsPublic, tournamentType, playerIds } = tournament;
  const { updateTournament } = useTournamentUpdate();

  const togglePublicity = async () => {
    const tournamentRef = doc(firestore, "tournaments", tournamentId);

    updateTournament("isTeamsPublic", !isTeamsPublic);
    try {
      await updateDoc(tournamentRef, { isTeamsPublic: !isTeamsPublic });
    } catch (error) {
      alert("Something went wrong updating the visibility!", error.message);
    }
  };

  if (!isTeamsPublic && !isUserOrganizer) {
    return;
  }
  const exportToCSV = () => {
  if (!teams) {
    console.warn("No teams found to export");
    return;
  }

  // Flatten into rows
  const rows = Object.values(teams).map((team) => {
    const { name, profileIds } = team;
    return [name, ...profileIds].join(",");
  });

  // Join rows into CSV string
  const csvContent = rows.join("\n");

  // Trigger file download
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "teams.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  console.log("Exported CSV:\n", csvContent);
};

  return (
    <section className="w-full flex flex-col items-center mb-6">
      <SectionTitle
        title={"Teams"}
        isPublic={isTeamsPublic}
        handlePublicity={togglePublicity}
      />

      {teams && Object.keys(teams).length > 0 && (
        <div className="w-full flex flex-wrap justify-center gap-6 my-8">
          {Object.keys(teams).map((teamId) => {
            const team = teams[teamId];

            if (!team) return null;

            return <TeamCard key={teamId} team={team} teamId={teamId} />;
          })}
        </div>
      )}

      {isUserOrganizer && (
        <>
          {tournamentType === "MIXER" ? (
            <CreateMixerTeams
              tournamentId={tournamentId}
              playerIds={playerIds}
              profiles={profiles}
            />
          ) : (
            <AddMockTeams
              numberOfTeams={teams ? Object.keys(teams).length : 0}
            />
          )}
          <Button
            color="blue"
            onClick={exportToCSV}
            dataTestId="export-teams-to-csv-button"
          >
            Export Teams to CSV
          </Button>
        </>
      )}
    </section>
  );
};

export default Teams;
